import { MouseEventHandler } from 'react';
import { IconButton, Tooltip } from '@mui/material';

import { useStyles } from './styles';

interface IProps {
  handleClick?: MouseEventHandler<HTMLButtonElement>;
  iconAlt: string;
  icon: string;
  title: string;
  width?: number;
}

export const HoverIcon = ({ handleClick, iconAlt, icon, title, width = 30 }: IProps) => {
  const classes = useStyles();

  return (
    <>
      <Tooltip id="index__components-hover-icon__tooltip__l19" title={title} PopperProps={{ className: classes.popper }}>
        <IconButton id="index__components-hover-icon__iconbutton__l20" onClick={handleClick} className={classes.selectionButton}>
          <img id="index__components-hover-icon__img__l21"
          alt={iconAlt}
          src={icon}
          className={classes.selectionIcon}
          style={{ width, height: width }} />
          
        </IconButton>
      </Tooltip>
    </>);

};